import React from 'react';
import { useTranslation } from 'react-i18next';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import Select from '@/components/common/Select/Select';
import { convertLabelToOption } from '@/components/common/ProductUtilities';
import { FormGroupProps } from './types';
import { IOptions } from '@/data/models/option';

type Props = FormGroupProps & {
  loadLabels: (inputText: string | null, callback: any) => void;
  handleLabelSelect: (value: IOptions) => void;
};

export default function LabelFormGroup({
  album,
  disabled,
  readonly,
  loadLabels,
  showValidationErrors,
  fieldHasErrors,
  findErrorMessage,
  handleLabelSelect,
}: Props) {
  const { t } = useTranslation();
  const hasErrors =
    fieldHasErrors('Label') ||
    (showValidationErrors && !album.label?.adminOrgId);

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.product.label"
      hasErrors={hasErrors}
    >
      <Select
        id="label"
        labelTitle={t('product.editProduct.labelname')}
        labelClass="col-sm-3 form-label"
        isClearable={!readonly}
        loadOptions={loadLabels}
        placeholder=""
        data-testid="label-select"
        onChange={(e: IOptions) => handleLabelSelect(e)}
        initialOption={
          album.label?.adminOrgId
            ? convertLabelToOption(album.label)
            : undefined
        }
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
        hasErrors={hasErrors}
        errorMessage={findErrorMessage('Label')}
        isRequired={true}
        showValidationErrors={showValidationErrors}
        fieldValidationKey="productEditMode.Label"
      />
    </FormGroupWithTooltip>
  );
}
